import React from "react";
import _ from "lodash";
import Logger from "../../util/Logger";
import "./Select.scss";

export default class Select extends React.Component {
  constructor(props) {
    super(props);

    const { value, itemList, onSelected } = this.props;

    if (!value) {
      Logger.assert("Cannot create Select without value");
    }
    if (!itemList) {
      Logger.assert("Cannot create Select without itemList");
    }
    if (!onSelected) {
      Logger.assert("Cannot create Select without onSelected callback");
    }

    _.forEach(itemList, (item, i) => {
      if (!item) {
        Logger.assert(
          `Cannot create Select without valid item in itemList: ${i}`
        );
      }

      if (!item.id) {
        Logger.assert(`Cannot create Select: item missing id: ${i}`);
      }

      if (!item.text) {
        Logger.assert(`Cannot create Select: item missing text: ${i}`);
      }

      if (!item.value) {
        Logger.assert(`Cannot create Select: item missing value: ${i}`);
      }
    });
  }

  render() {
    const { id, value, itemList, onSelected, disabled, border } = this.props;

    // Removed excessive console log that was causing performance issues

    const selectedItem = itemList.find((item) => item.value === value) || {
      text: "",
    };

    return (
      <div id={id} className={`dropdown select ${border ? "" : "borderless"}`}>
        <button
          className="btn dropdown-toggle"
          type="button"
          aria-haspopup="true"
          aria-expanded="false"
          disabled={disabled}
          data-toggle={`${disabled ? "" : "dropdown"}`}
        >
          {selectedItem.text}
        </button>
        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
          {itemList.map((item) => (
            <button
              className="dropdown-item"
              type="button"
              id={item.id}
              key={item.id}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                onSelected(item);
              }}
            >
              {item.text}
            </button>
          ))}
        </div>
      </div>
    );
  }
}

Select.defaultProps = {
  border: true,
  disabled: false,
};
